import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Logs an anonymous pageview (path, country, bot flag) so the SEO dashboard can
 * report real human traffic from India. No personal data is stored.
 */
export const useVisitTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let done = false;
    const send = async () => {
      if (done) return;
      done = true;
      cleanup();
      const nav = navigator as Navigator & { webdriver?: boolean };
      const [{ supabase }, { trackPageViewConversion }] = await Promise.all([
        import("@/integrations/supabase/client"),
        import("@/lib/gads"),
      ]);
      trackPageViewConversion();
      supabase.functions
        .invoke("track-visit", {
          body: {
            path: pathname,
            referrer: document.referrer || null,
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            headless: nav.webdriver === true,
          },
        })
        .catch(() => {});
    };
    // The tracking bundle is heavy, so it loads on the visitor's first
    // interaction (or well after load) to keep the first render fast.
    const events = ["pointerdown", "keydown", "touchstart", "scroll"] as const;
    const cleanup = () => {
      events.forEach((e) => window.removeEventListener(e, send));
      window.clearTimeout(t);
    };
    events.forEach((e) => window.addEventListener(e, send, { once: true, passive: true }));
    const t = window.setTimeout(send, 9000);
    return cleanup;
  }, [pathname]);
};

export const VisitTracker = () => {
  useVisitTracking();
  return null;
};
